// Site header scrolling
var $ = window.jQuery;
var win, doc, body, scrollPosY, BlogBox, BlogBoxTop, BlogBoxBottom;

function onDocumentReady() {
	win = window;
	doc = document;
	body = $(document.body);

	if ($('.blog').length > 0 || $('.search').length > 0 || $('.category').length > 0) {
		$('.share-heading').on('click', function() {
			$(this)
				.closest('.share')
				.toggleClass('active-share');
		});
	}

	if (body.hasClass('single-post') && body.hasClass('post-type-post')) {
		BlogBox = doc.getElementById('blog-post-content');

		BlogcontentBox();

		win.addEventListener('scroll', changeClass);
		win.addEventListener('resize', debounce(BlogcontentBox, 250));
	}

	// Replace all SVG images with inline SVG
	svgImage();
}

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this,
			args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

/**
 * Toggles class on body element based on window scroll position
 */
function changeClass() {
	scrollPosY = win.pageYOffset | doc.body.scrollTop;

	// If scrolled past the hero
	if (scrollPosY > BlogBoxTop) {
		$('.blog-post-share').addClass('sticky-share-fixed');
	} else if (scrollPosY <= BlogBoxTop) {
		$('.blog-post-share').removeClass('sticky-share-fixed');
	}

	// If scrolled past the hero
	if (scrollPosY > BlogBoxBottom) {
		$('.blog-post-share').addClass('sticky-share-absolute');
	} else if (scrollPosY <= BlogBoxBottom) {
		$('.blog-post-share').removeClass('sticky-share-absolute');
	}
}

/**
 * Returns element bounding box details
 */
function BlogcontentBox() {
	var BlogBoxbounds = BlogBox.getBoundingClientRect();
	BlogBoxTop = $(BlogBox).offset().top - $('.main-nav').height();
	BlogBoxBottom = BlogBoxbounds.height - $('.blog-post-share').height();
}

/**
 * Blog page category filter function
 */
var blogCatNav = document.getElementById('blog-filter-cat');

if (blogCatNav) {
	/**
	 * Blog filter category select navigation
	 */
	blogCatNav.addEventListener('change', function() {
		var termUrl = this.options[this.selectedIndex].value;
		if (termUrl !== '') {
			document.location.href = termUrl;
		}
	});

	/**
	 * Blog filter category select focus event controller
	 */
	var select = document.querySelectorAll('.blog-filter-cat-styled-select select'),
		focusClass = 'focus';

	Array.prototype.forEach.call(select, function(el, i) {
		var parent = el.parentNode;

		el.addEventListener('focus', function() {
			if (parent.classList) {
				parent.classList.add(focusClass);
			} else {
				parent.className += ' ' + focusClass;
			}
		});

		el.addEventListener('blur', function() {
			if (parent.classList) {
				parent.classList.remove(focusClass);
			} else {
				parent.className = parent.className.replace(new RegExp('(^|\\b)' + focusClass.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
			}
		});
	});
}

/*
 * Replace all SVG images with inline SVG
 */
function svgImage() {
	$('img.svg').each(function() {
		var $img = jQuery(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');

		$.get(
			imgURL,
			function(data) {
				// Get the SVG tag, ignore the rest
				var $svg = jQuery(data).find('svg');

				// Add replaced image's ID to the new SVG
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg');
				}

				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');

				// Check if the viewport is set, if the viewport is not set the SVG wont't scale.
				if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
					$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
				}

				// Replace image with new SVG
				$img.replaceWith($svg);
			},
			'xml'
		);
	});
}

document.addEventListener('DOMContentLoaded', function() {
	onDocumentReady();
});
